export default __webpack_public_path__ + "static/media/SWT1370.34I-34970_-24393_0.df34dcc6.jpg";